// src/features/invoice/components/InvoiceStatusBadge.jsx
import React from "react";
import { Chip } from "@mui/material";
import {
  getStatusLabel,
  getStatusColor,
  getStatusIcon,
} from "../utils/invoiceHelpers";

const InvoiceStatusBadge = ({ status, size = "small", ...props }) => {
  const label = getStatusLabel(status);
  const color = getStatusColor(status);
  const icon = getStatusIcon(status);

  return (
    <Chip
      label={label}
      icon={<span>{icon}</span>}
      size={size}
      sx={{
        backgroundColor: color + "20",
        color: color,
        borderColor: color,
        fontWeight: 500,
        "& .MuiChip-icon": {
          marginLeft: "4px",
          fontSize: "14px",
        },
      }}
      variant="outlined"
      {...props}
    />
  );
};

export default InvoiceStatusBadge;
